const ThreeDots = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99984 10.8332C10.4601 10.8332 10.8332 10.4601 10.8332 9.99984C10.8332 9.5396 10.4601 9.1665 9.99984 9.1665C9.5396 9.1665 9.1665 9.5396 9.1665 9.99984C9.1665 10.4601 9.5396 10.8332 9.99984 10.8332Z"
      fill="currentColor"
    />
    <path
      d="M16.8748 10.8332C17.3351 10.8332 17.7082 10.4601 17.7082 9.99984C17.7082 9.5396 17.3351 9.1665 16.8748 9.1665C16.4146 9.1665 16.0415 9.5396 16.0415 9.99984C16.0415 10.4601 16.4146 10.8332 16.8748 10.8332Z"
      fill="currentColor"
    />
    <path
      d="M3.12484 10.8332C3.58507 10.8332 3.95817 10.4601 3.95817 9.99984C3.95817 9.5396 3.58507 9.1665 3.12484 9.1665C2.6646 9.1665 2.2915 9.5396 2.2915 9.99984C2.2915 10.4601 2.6646 10.8332 3.12484 10.8332Z"
      fill="currentColor"
    />
    <path
      d="M9.99984 10.8332C10.4601 10.8332 10.8332 10.4601 10.8332 9.99984C10.8332 9.5396 10.4601 9.1665 9.99984 9.1665C9.5396 9.1665 9.1665 9.5396 9.1665 9.99984C9.1665 10.4601 9.5396 10.8332 9.99984 10.8332Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8748 10.8332C17.3351 10.8332 17.7082 10.4601 17.7082 9.99984C17.7082 9.5396 17.3351 9.1665 16.8748 9.1665C16.4146 9.1665 16.0415 9.5396 16.0415 9.99984C16.0415 10.4601 16.4146 10.8332 16.8748 10.8332Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.12484 10.8332C3.58507 10.8332 3.95817 10.4601 3.95817 9.99984C3.95817 9.5396 3.58507 9.1665 3.12484 9.1665C2.6646 9.1665 2.2915 9.5396 2.2915 9.99984C2.2915 10.4601 2.6646 10.8332 3.12484 10.8332Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default ThreeDots
